import { useState } from "react";
import { pricingPlan } from "../../data";
import PricingPlanCard from "./PricingPlanCard";
import PricingPlanQuestionsBox from "./PricingPlanQuestionsBox";
import ReserveSlotModal from "./ReserveSlotModal";

const PricingPlans = () => {
  const [planType, setPlanType] = useState("");
  const [reserveModal, setReserveModal] = useState(false);
  const [modalKey, setModalKey] = useState(0);

  const openReserveModal = () => {
    setModalKey((k) => k + 1);
    setReserveModal(true);
  };

  const closeReserveModal = () => {
    setReserveModal(false);
  };

  return (
    <>
      <div className="d-flex flex-column justify-content-center justify-content-lg-between flex-lg-row gap-5">
        {pricingPlan.plans.map((plan) => (
          <PricingPlanCard
            key={plan.id}
            plan={plan}
            setPlanType={setPlanType}
            openReserveModal={openReserveModal}
          />
        ))}
      </div>
      <div className="d-none d-lg-block">
        <div className="d-flex flex-column justify-content-center justify-content-lg-between flex-lg-row gap-5">
          {pricingPlan.plans.map((plan) => (
            <PricingPlanQuestionsBox key={plan.id} plan={plan} inMobileView />
          ))}
        </div>
      </div>
      <ReserveSlotModal
        key={modalKey}
        show={reserveModal}
        onHide={closeReserveModal}
        planType={planType}
      />
    </>
  );
};

export default PricingPlans;
